import React, { useState, useEffect } from "react";
import liff from '@line/liff';
import "../css/Setting.css";
import { Collapse, Checkbox, Button, Modal, Space, Col, Row, Switch, Skeleton, Empty } from "antd";
import CreateMap from "./CreateMap";
import header_image from "../image/header_image.png";
import delete_icon from "../image/delete_icon.jpg";
import location_icon from "../image/location.png";
import useCustom from "../customHook/customHook";
import * as hasura from "../service/hasura";
import ModalAlert from "./ModalAlert";
const constants = require("../configs/constants");

// Module-level reverse-geocode cache to eliminate redundant Kong reverse-geo API calls
const geoCache = new Map();

export const fetchReverseGeo = async (lat, lng) => {
  if (!lat || !lng) {
    return { province: '', district: '', sub_district: '', formattedName: '' };
  }
  const key = `${Number(lat).toFixed(5)},${Number(lng).toFixed(5)}`;
  if (geoCache.has(key)) {
    return geoCache.get(key);
  }

  let requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };

  try {
    const response = await fetch(
      `https://kong.traffy.in.th/fondue-reverse-geo/?action=find&latlng=${lat},${lng}&limit=1`,
      requestOptions
    );
    const result = await response.json();
    const data = {
      province: result.province || '',
      district: result.district || '',
      sub_district: result.subdistrict || '',
      formattedName: `${result.subdistrict || ''} ${result.district || ''} ${result.province || ''}`.trim(),
    };
    if (data.formattedName) {
      geoCache.set(key, data);
    }
    return data;
  } catch (error) {
    console.error('Reverse geocode error:', error);
    return {
      province: '',
      district: '',
      sub_district: '',
      formattedName: '',
    };
  }
};

export const getMapDetail = async (lat, lng) => {
  const geo = await fetchReverseGeo(lat, lng);
  return geo.formattedName;
};

// import VConsole from 'vconsole';
// const vConsole = new VConsole();

export default function NewNotiSettings(props) {
  const [globalState, setGlobalState] = useCustom();
  const [error, setError] = useState();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [userProfile, setUserProfile] = useState();
  const [userID, setUserID] = useState();
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [headerName, setHeaderName] = useState("รับการแจ้งเตือน");
  const [itemNum, setItemNum] = useState(2);
  const [defaultCheckedValues, setDefaultCheckedValues] = useState([]);
  const [checkedValues, setCheckedValues] = useState([]);
  const [checkedValuesDisplay, setCheckedValuesDisplay] = useState('');
  const [locationNameInput, setLocationNameInput] = useState();
  const [checkboxList, setCheckboxList] = useState();
  const [notiSaved, setnotiSaved] = useState();
  const [optionsListNews, setOptionsListNews] = useState([]);
  const [traffyUserId, setTraffyUserId] = useState();
  const [subscriptionAreas, setSubscriptionAreas] = useState();
  const [currentSubscriptionId, setCurrentSubscriptionId] = useState(0);
  const [subscriptionId, setSubscriptionId] = useState(0);
  const [currentSubscriptionName, setCurrentSubscriptionName] = useState("");
  const [initMap, setinitMap] = useState();
  const [notiStatus, setNotiStatus] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [typeAlert, setTypeAlert] = useState(false);
  const [isLoadingSubscriptions, setIsLoadingSubscriptions] = useState(true);

  useEffect(() => {
    //document.body.style.backgroundColor = '#F8F8F8';
    document.body.style.backgroundColor = '#FFFFFF';
    initLIFF();
    setinitMap(<CreateMap />);
  }, []);

  const initLIFF = async () => {
    try {
      await liff.init({ liffId: '2000158432-KG21Xked', withLoginOnExternalBrowser: true }); //ตัวจริง
      // await liff.init({ liffId: '2000158432-lGXm1gGk', withLoginOnExternalBrowser: true }); //ทดสอบ
      setIsLoggedIn(liff.isLoggedIn());
      setIsReady(true);
      // liff.scanCodeV2(); เอาไว้ทดสอบว่าติด cache รึเปล่า
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    if (!isLoggedIn) return;

    (async () => {
      const profile = await liff.getProfile();
      setGlobalState({ line_user_profile: profile.pictureUrl })
      setGlobalState({ line_user_id: profile.userId })
      setUserProfile(profile);
      setUserID(profile.userId);
      await hasura.ensureAuth(profile.userId);
      hasura.getListOption().then((res) => {
        setOptionsListNews(res.fondue_alert_news_type);
      });
      hasura.getTraffyId(profile.userId).then((res) => {
        setTraffyUserId(res.traffy_user[0].id);
        setGlobalState({ traffy_user_id: res.traffy_user[0].id })
      });
      hasura.getListSubscription(profile.userId).then((res) => {
        setSubscriptionAreas(res);
      });
      //getListType(profile.userId);
    })();
  }, [isLoggedIn]);

  useEffect(() => {
    if (subscriptionAreas) {
      getListType(userID, subscriptionAreas);
    }
  }, [subscriptionAreas, optionsListNews]);

  useEffect(() => {
    if (currentSubscriptionId !== 0) {
      loadSaveSubscription(currentSubscriptionId);
    }
  }, [currentSubscriptionId]);
  
  const loadSaveSubscription = (targetId = currentSubscriptionId) => {
    if (!targetId || targetId === 0) return;

    const result = subscriptionAreas?.traffy_user?.[0]?.traffy_user_user_subscription_areas?.find(
      (item) => item.id === targetId
    );
    if (!result) return;

    let current_checked = [];
    (result.user_subscription_areas_user_subscription_news_type_in_areas || []).forEach((element) => {
      if (element.notification_status === true && element.user_subscription_news_type_in_areas_news_type?.name) {
        current_checked.push(element.user_subscription_news_type_in_areas_news_type.name);
      }
    });

    setCheckedValues(current_checked);
    setDefaultCheckedValues(current_checked);
    if (result.lat && result.lon) {
      setGlobalState({
        current_coors: { lng: parseFloat(result.lon), lat: parseFloat(result.lat) },
      });
    }
  };

  const processSubscriptionAreas = async (areasData = subscriptionAreas) => {
    const areas = areasData?.traffy_user?.[0]?.traffy_user_user_subscription_areas || [];
    setItemNum(areas.length);

    if (areas.length === 0) {
      setnotiSaved([]);
      setIsLoadingSubscriptions(false);
      return;
    }

    // Use location_name from database relation if present (0ms); fallback to getMapDetail only if missing
    const locationNames = await Promise.all(
      areas.map((element) => {
        if (element.location_name) {
          return element.location_name;
        }
        return getMapDetail(element.lat, element.lon);
      })
    );

    const saved = areas.map((element, index) => {
      const location_name = locationNames[index] || '';

      const checked_box = (
        element.user_subscription_areas_user_subscription_news_type_in_areas || []
      )
        .filter((e) => e.notification_status === true)
        .map((e, idx) => (
          <div className="btn-selected " key={e.id || idx}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M8.17835 14.1216L4.70335 10.6466L3.52002 11.8216L8.17835 16.4799L18.1784 6.47989L17.0034 5.30489L8.17835 14.1216Z"
                fill="black"
              />
            </svg>
            <span>{e.user_subscription_news_type_in_areas_news_type?.name}</span>
          </div>
        ));

      return (
        <div className="box-saved" key={element.id}>
          <div className="title-text">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              style={{ marginTop: "3px" }}
            >
              <path
                d="M10.1784 2.01967C6.95337 2.01967 4.34503 4.628 4.34503 7.853C4.34503 12.228 10.1784 18.6863 10.1784 18.6863C10.1784 18.6863 16.0117 12.228 16.0117 7.853C16.0117 4.628 13.4034 2.01967 10.1784 2.01967ZM10.1784 9.93634C9.62583 9.93634 9.09593 9.71684 8.70523 9.32614C8.31453 8.93544 8.09503 8.40554 8.09503 7.853C8.09503 7.30047 8.31453 6.77056 8.70523 6.37986C9.09593 5.98916 9.62583 5.76967 10.1784 5.76967C10.7309 5.76967 11.2608 5.98916 11.6515 6.37986C12.0422 6.77056 12.2617 7.30047 12.2617 7.853C12.2617 8.40554 12.0422 8.93544 11.6515 9.32614C11.2608 9.71684 10.7309 9.93634 10.1784 9.93634Z"
                fill="black"
              />
            </svg>
            <span className="location-name">พื้นที่: {location_name}</span>
            <img
              onClick={() => handleDelete(element)}
              style={{
                width: "20px",
                height: "20px",
                marginLeft: "4px",
                marginBottom: "3px",
                marginTop: "3px",
                cursor: "pointer",
              }}
              src={delete_icon}
              alt="delete"
            />
          </div>
          <div className="box-button">
            <Switch
              className="title-button"
              defaultChecked={element.notification_status}
              onChange={(checked) => onToggleChange(checked, element)}
            />
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div className="body-footer">
              <div style={{ display: "flex", width: "20px" }}>
                <span>&nbsp;</span>
              </div>
              <div className="display-footer">{checked_box}</div>
            </div>
            <div className="edit-footer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setIsEdit(true);
                  setHeaderName("แก้ไข");
                  setCurrentSubscriptionId(element.id);
                  setNotiStatus(element.notification_status);
                  loadSaveSubscription(element.id);
                }}
              >
                <path
                  d="M23.1408 13.8528C22.8535 13.8528 22.578 13.9669 22.3748 14.1701C22.1716 14.3732 22.0575 14.6488 22.0575 14.9361V21.4361C22.0575 21.7234 21.9434 21.999 21.7402 22.2021C21.537 22.4053 21.2615 22.5194 20.9742 22.5194H5.80749C5.52018 22.5194 5.24463 22.4053 5.04146 22.2021C4.8383 21.999 4.72416 21.7234 4.72416 21.4361V6.26945C4.72416 5.98213 4.8383 5.70658 5.04146 5.50342C5.24463 5.30025 5.52018 5.18612 5.80749 5.18612H12.3075C12.5948 5.18612 12.8704 5.07198 13.0735 4.86882C13.2767 4.66565 13.3908 4.3901 13.3908 4.10278C13.3908 3.81547 13.2767 3.53992 13.0735 3.33675C12.8704 3.13359 12.5948 3.01945 12.3075 3.01945H5.80749C4.94554 3.01945 4.11889 3.36186 3.5094 3.97135C2.8999 4.58085 2.5575 5.4075 2.5575 6.26945V21.4361C2.5575 22.2981 2.8999 23.1247 3.5094 23.7342C4.11889 24.3437 4.94554 24.6861 5.80749 24.6861H20.9742C21.8361 24.6861 22.6628 24.3437 23.2723 23.7342C23.8818 23.1247 24.2242 22.2981 24.2242 21.4361V14.9361C24.2242 14.6488 24.11 14.3732 23.9069 14.1701C23.7037 13.9669 23.4281 13.8528 23.1408 13.8528ZM6.89083 14.6761V19.2694C6.89083 19.5568 7.00496 19.8323 7.20813 20.0355C7.41129 20.2386 7.68684 20.3528 7.97416 20.3528H12.5675C12.7101 20.3536 12.8514 20.3263 12.9834 20.2724C13.1154 20.2185 13.2354 20.139 13.3367 20.0386L20.8333 12.5311L23.91 9.51945C24.0115 9.41874 24.0921 9.29892 24.1471 9.16691C24.2021 9.03489 24.2304 8.8933 24.2304 8.75028C24.2304 8.60727 24.2021 8.46567 24.1471 8.33366C24.0921 8.20164 24.0115 8.08183 23.91 7.98112L19.3167 3.33362C19.216 3.23208 19.0961 3.15148 18.9641 3.09648C18.8321 3.04148 18.6905 3.01317 18.5475 3.01317C18.4045 3.01317 18.2629 3.04148 18.1309 3.09648C17.9989 3.15148 17.879 3.23208 17.7783 3.33362L14.7233 6.39945L7.20499 13.9069C7.10459 14.0082 7.02515 14.1282 6.97124 14.2602C6.91733 14.3922 6.89 14.5335 6.89083 14.6761ZM18.5475 5.63028L21.6133 8.69612L20.075 10.2344L17.0092 7.16862L18.5475 5.63028ZM9.05749 15.1203L15.4817 8.69612L18.5475 11.7619L12.1233 18.1861H9.05749V15.1203Z"
                fill="black"
                fillOpacity="0.5"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  });

  setnotiSaved(saved);
  setIsLoadingSubscriptions(false);
};

  const getListType = async (currentUserID = userID, areasData = subscriptionAreas) => {
    let rows = [];

    await processSubscriptionAreas(areasData);

    optionsListNews.forEach((element) => {
      const name = element.name;
      const spanValue = name.length <= 12 ? 8 : name.length <= 18 ? 16 : 24;
      rows.push(
        <Col span={spanValue} style={colStyle} key={element.id || name}>
          <Checkbox value={name}>
            <span className="options-text">{name}</span>
          </Checkbox>
        </Col>
      );
    });

    setDefaultCheckedValues([]);
    setCheckboxList(
      <Row>
        {rows}
      </Row>
    );
  };

  const logOut = ()=>{
    window.location.reload();
    liff.logout();
  }

  const lineLogin = () => {
    if (error && !isLoggedIn) {
      return <p>เข้าสู่ระบบไม่สำเร็จ</p>;
    }
    if (!isReady) return <p>กำลังโหลด...</p>;

    if (!isLoggedIn) {
      return (
        <Button className="text-button" onClick={liff.login}>
          <span>Login</span>
        </Button>
      );
    }

    if (!liff.isInClient()) {
      return (
        <>
          <Button className="text-button" onClick={logOut}>
            <span>Logout</span>
          </Button>
        </>
      );
    }
  };

  const onChange = (checkedValues) => {
    setCheckedValues(checkedValues);

    let checked = '';
    checkedValues?.forEach((element, index, array) => {
      checked += element;
      if (index < array.length - 1) {
        checked += ', ';
      }
    });

    setCheckedValuesDisplay(checked);
  };

  const onToggleChange = async (checked, element) => {
    let province;
    let district;
    let sub_district;
    let area_id;

    let requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    /*
    try {
      const response = await fetch(`https://kong.traffy.in.th/fondue-reverse-geo/?action=find&latlng=${element.lat},${element.lon}&limit=1`, requestOptions);
      const result = await response.json();
      province = result.province;
      district = result.district;
      sub_district = result.subdistrict;
    } catch (error) {
      //console.error('error', error);
    }
    

    try {
      let res = await hasura.getAreaID(province, district, sub_district);
      area_id = res.result[0].id;
    } catch (error) {
      //console.error(error);
    }
    */
    
    hasura.updateAreaUser(element.id, element.area_id, element.lat, element.lon, checked).then((res) => {
      //console.log(res, element.id, element.area_id, element.lat, element.lon, checked)
    });
    
  };

  const colStyle = {
    marginBottom: '16px', // Adjust the margin to control the gap
  };

  const handlelocationNameInputChange = (event) => {
    setLocationNameInput(event.target.value);
  };

  const handleDelete = (element) => {
    setSubscriptionId(element.id);
    setCurrentSubscriptionName(element.name);
    setTypeAlert("alert_delete");
    handleShowAlert(true);
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;

    if (!checkedValues || checkedValues.length === 0) {
      Modal.warning({
        title: 'บันทึกไม่สำเร็จ',
        content: 'กรุณาเลือกประเภท',
      });
      return;
    }
    const lat = globalState.user_address_location?.lat || globalState.current_coors?.lat;
    const lng = globalState.user_address_location?.lng || globalState.current_coors?.lng;

    if (!lat || !lng) {
      Modal.warning({
        title: 'บันทึกไม่สำเร็จ',
        content: 'กรุณาเลือกพื้นที่',
      });
      return;
    }

    setIsSubmitting(true);

    try {
      let province;
      let district;
      let sub_district;
      let area_id;
      let user_subscription_area_id;

      const geo = await fetchReverseGeo(lat, lng);
      province = geo.province;
      district = geo.district;
      sub_district = geo.sub_district;

      if (!province || !district || !sub_district) {
        setIsSubmitting(false);
        Modal.warning({
          title: 'บันทึกไม่สำเร็จ',
          content: 'กรุณาเลือกพื้นที่ภายในประเทศ',
        });
        return;
      }

      let resArea = await hasura.getAreaID(province, district, sub_district);
      if (resArea?.result?.length > 0) {
        area_id = resArea.result[0].id;
      } else {
        let resSave = await hasura.saveArea(province, district, sub_district);
        area_id = resSave.insert_fondue_alert_areas.returning[0].id;
      }

      if (currentSubscriptionId === 0) {
        let res = await hasura.saveAreaUser(
          area_id,
          lat,
          lng,
          traffyUserId
        );
        user_subscription_area_id = res.insert_fondue_alert_user_subscription_areas.returning[0].id;
      } else {
        let res = await hasura.updateAreaUser(
          currentSubscriptionId,
          area_id,
          lat,
          lng,
          notiStatus
        );
        user_subscription_area_id = res.update_fondue_alert_user_subscription_areas.returning[0].id;
      }

      if (!user_subscription_area_id) {
        throw new Error("Unable to obtain user subscription area ID");
      }

      // Batch save all options in one single PostgREST call (~80ms)!
      const batchItems = optionsListNews.map((element) => ({
        news_type_id: element.id,
        user_subscription_area_id: user_subscription_area_id,
        notification_status: !!checkedValues?.includes(element?.name),
      }));
      await hasura.saveSubscriptionUserBatch(batchItems);

      let checked = '';
      checkedValues?.forEach((element, index, array) => {
        checked += element;
        if (index < array.length - 1) {
          checked += ', ';
        }
      });
      setCheckedValuesDisplay(checked);

      // Fetch fresh subscription areas immediately and update UI in-memory
      const freshAreas = await hasura.getListSubscription(userID);
      setSubscriptionAreas(freshAreas);
      await getListType(userID, freshAreas);

      setHeaderName("รับการแจ้งเตือน");
      setCurrentSubscriptionId(0);
      setIsEdit(false);
    } catch (error) {
      console.error("Submit error:", error);
      Modal.error({
        title: 'เกิดข้อผิดพลาด',
        content: 'ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOffModalChangeStatusAlert = () => {
    props.offModalChangeStatus(false);
    props.refresh(true);
  };

  const handleShowAlert = (status) => {
    setShowAlert(status);
  };

  return (
    <section className="app">
      {showAlert && (
        <ModalAlert
          subscriptionId={subscriptionId}
          currentSubscriptionName={currentSubscriptionName}
          typeAlert={typeAlert}
          statusShow={handleShowAlert}
          closeModal={handleOffModalChangeStatusAlert}
          onDeleteSuccess={async () => {
            const fresh = await hasura.getListSubscription(userID);
            setSubscriptionAreas(fresh);
            await getListType(userID, fresh);
          }}
        />
      )}
      {/*
      <div className="Login">
        {<header>{lineLogin()}</header>}
      </div>
      */}
      
      {isLoggedIn &&
      <>
        <div className="container-body">
          <div style={{ display: "flex", borderBottom: "1px solid rgba(0, 0, 0, 0.10)", alignItems: "center" }}>
            <span className="text-header">{headerName}</span>
            {/*<img style={{ width: "20px", height: "20px", marginLeft: "4px", marginBottom: "10px" }} src={location_icon} />*/}
          </div>


          {isEdit === false && (
            <>
              {isLoadingSubscriptions ? (
                <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "16px" }}>
                  {[1, 2, 3].map((i) => (
                    <div
                      key={i}
                      style={{
                        padding: "16px",
                        borderRadius: "12px",
                        border: "1px solid rgba(0, 0, 0, 0.08)",
                        background: "#FFFFFF",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
                      }}
                    >
                      <Skeleton active avatar={{ shape: "circle", size: 32 }} paragraph={{ rows: 2 }} />
                    </div>
                  ))}
                </div>
              ) : notiSaved && notiSaved.length > 0 ? (
                notiSaved
              ) : (
                <div style={{ textAlign: "center", padding: "40px 16px" }}>
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="ยังไม่มีการตั้งค่าพื้นที่รับแจ้งเตือน" />
                </div>
              )}
            </>
          )}

          {isEdit === true &&
            <>
              {/*<span className="text-topic">สถานที่</span>
              <div className="box-body">
                <input
                  type="text"
                  value={locationNameInput}
                  onChange={handlelocationNameInputChange}
                  placeholder="พิมพ์ชื่อเรียกสถานที่ เช่น บ้าน, ที่ทำงาน"
                />
              </div>
              */}

              <span className="text-topic">หัวข้อที่สนใจ</span>
              <Checkbox.Group
                style={{
                  width: '100%',
                }}
                onChange={onChange}
                value={checkedValues}
              >
                {checkboxList}
              </Checkbox.Group>

              <span className="text-topic-2nd">พื้นที่รับแจ้ง</span>
              {<div style={{ width: "100%" }}>{initMap}</div>}
            </>
          }
        </div>

        {itemNum <= 4 && isEdit === false && liff.isInClient() &&
          <>
            <dic className="container-adding">
              <div className="back-body" onClick={() => {liff.closeWindow()}}>
                <span className="text-back">กลับ</span>
              </div>
              <div className="box-body" onClick={() => {setIsEdit(true); setHeaderName("เพิ่มการแจ้งเตือน"); setCurrentSubscriptionId(0); setCheckedValues(['เหตุฉุกเฉิน', 'ข่าวสาร', 'ผลงาน']); setDefaultCheckedValues(['เหตุฉุกเฉิน', 'ข่าวสาร', 'ผลงาน']); setLocationNameInput(); setGlobalState({ current_coors: {lng: 100.4992487, lat: 13.7538189} });}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path d="M15.0123 11.1847H10.8456V15.3513C10.8456 15.5723 10.7578 15.7843 10.6015 15.9406C10.4453 16.0969 10.2333 16.1847 10.0123 16.1847C9.79127 16.1847 9.57931 16.0969 9.42303 15.9406C9.26675 15.7843 9.17896 15.5723 9.17896 15.3513V11.1847H5.01229C4.79127 11.1847 4.57931 11.0969 4.42303 10.9406C4.26675 10.7843 4.17896 10.5723 4.17896 10.3513C4.17896 10.1303 4.26675 9.91835 4.42303 9.76207C4.57931 9.60579 4.79127 9.51799 5.01229 9.51799H9.17896V5.35132C9.17896 5.13031 9.26675 4.91835 9.42303 4.76207C9.57931 4.60579 9.79127 4.51799 10.0123 4.51799C10.2333 4.51799 10.4453 4.60579 10.6015 4.76207C10.7578 4.91835 10.8456 5.13031 10.8456 5.35132V9.51799H15.0123C15.2333 9.51799 15.4453 9.60579 15.6015 9.76207C15.7578 9.91835 15.8456 10.1303 15.8456 10.3513C15.8456 10.5723 15.7578 10.7843 15.6015 10.9406C15.4453 11.0969 15.2333 11.1847 15.0123 11.1847Z" fill="black" fill-opacity="0.5"/>
                </svg>
                <span className="text-body">เพิ่มการแจ้งเตือน</span>
              </div>
            </dic>
          </>
        }

        {itemNum > 4 && isEdit === false && liff.isInClient() &&
          <>
            <dic className="container-adding">
              <div className="back-body-full" onClick={() => {liff.closeWindow()}}>
                <span className="text-back">กลับ</span>
              </div>
            </dic>
          </>
        }

        {itemNum <= 4 && isEdit === false && !liff.isInClient() &&
          <>
            <dic className="container-adding">
              <div className="box-body-pc" onClick={() => {setIsEdit(true); setHeaderName("เพิ่มการแจ้งเตือน"); setCurrentSubscriptionId(0); setCheckedValues(['เหตุฉุกเฉิน', 'ข่าวสาร', 'ผลงาน']); setDefaultCheckedValues(['เหตุฉุกเฉิน', 'ข่าวสาร', 'ผลงาน']); setLocationNameInput(); setGlobalState({ current_coors: {lng: 100.4992487, lat: 13.7538189} });}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path d="M15.0123 11.1847H10.8456V15.3513C10.8456 15.5723 10.7578 15.7843 10.6015 15.9406C10.4453 16.0969 10.2333 16.1847 10.0123 16.1847C9.79127 16.1847 9.57931 16.0969 9.42303 15.9406C9.26675 15.7843 9.17896 15.5723 9.17896 15.3513V11.1847H5.01229C4.79127 11.1847 4.57931 11.0969 4.42303 10.9406C4.26675 10.7843 4.17896 10.5723 4.17896 10.3513C4.17896 10.1303 4.26675 9.91835 4.42303 9.76207C4.57931 9.60579 4.79127 9.51799 5.01229 9.51799H9.17896V5.35132C9.17896 5.13031 9.26675 4.91835 9.42303 4.76207C9.57931 4.60579 9.79127 4.51799 10.0123 4.51799C10.2333 4.51799 10.4453 4.60579 10.6015 4.76207C10.7578 4.91835 10.8456 5.13031 10.8456 5.35132V9.51799H15.0123C15.2333 9.51799 15.4453 9.60579 15.6015 9.76207C15.7578 9.91835 15.8456 10.1303 15.8456 10.3513C15.8456 10.5723 15.7578 10.7843 15.6015 10.9406C15.4453 11.0969 15.2333 11.1847 15.0123 11.1847Z" fill="black" fill-opacity="0.5"/>
                </svg>
                <span className="text-body">เพิ่มการแจ้งเตือน</span>
              </div>
            </dic>
          </>
        }

        <Modal
            title="บันทึกสำเร็จ"
            //centered
            open={open}
            onOk={() => setOpen(false)}
            footer={[
              <Button key="submit" type="primary" onClick={() => window.location.reload(false)}>
                ตกลง
              </Button>,
            ]}
          >
            <div>
              <span>พิกัด: {globalState.user_address_name}</span><br></br><br></br>
              <span>ประเภท: {checkedValuesDisplay}</span>
            </div>
          </Modal>

        {isEdit === true &&
          <>
            <div className="container-footer">
              <Button className="button-cancle" onClick={() => {setIsEdit(false); setHeaderName("รับการแจ้งเตือน"); setCurrentSubscriptionId(0); }}>
                <span className="submit-text">ยกเลิก</span>
              </Button>
              <Button
                className="button-submit"
                loading={isSubmitting}
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                <span className="submit-text">
                  {isSubmitting ? "กำลังบันทึก..." : "ยืนยัน"}
                </span>
              </Button>
            </div>
          </>
        }
      </>
      }
    </section>
  );
}
